const initalData = {
    tasks: {
        'task-1': { id: 'task-1', content: 'Leikjastjórnun | 2.5 klst', name: 'Leikjastjórnun' },
        'task-2': { id: 'task-2', content: 'Fjallamennska og rötun | 1', name: 'Fjallamennska og rötun' },
        'task-3': { id: 'task-3', content: 'Verkstæði skátaforingjans | 2.5 klst', name: 'Verkstæði skátaforingjans' },
        'task-4': { id: 'task-4', content: 'Hnífar og axir | 1 klst', name: 'Hnífar og axir' },
        'task-5': { id: 'task-5', content: 'Tjaldbúðameistarinn | 1 klst', name: 'Tjaldbúðameistarinn' },
        'task-6': { id: 'task-6', content: 'Skyndihjálp | 2.5 klst', name: 'Skyndihjálp' },
        'task-7': { id: 'task-7', content: 'Út að borða | 2.5 klst', name: 'Út að borða' },
        'task-8': { id: 'task-8', content: 'Eldmeistarinn | 2.5 klst', name: 'Eldmeistarinn' },
        'task-9': { id: 'task-9', content: 'Klifur og sig | 2.5 klst', name: 'Klifur og sig' },
        'task-10': { id: 'task-10', content: 'Jökulsprunguæfing | 1 klst', name: 'Jökulsprunguæfing' },
        'task-11': { id: 'task-11', content: 'Canva og hönnunarstaðall BÍS | 1 klst', name: 'Canva og hönnunarstaðall BÍS' },
        'task-12': { id: 'task-12', content: 'Hannaðu þitt eigið merki | 2.5 klst', name: 'Hannaðu þitt eigið merki' },
        'task-13': { id: 'task-13', content: 'Geimurinn, stjörnur og stjörnumerki | 2.5 klst', name: 'Geimurinn, stjörnur og stjörnumerki' },
        'task-14': { id: 'task-14', content: 'Saga skátastarfs | 1 klst', name: 'Saga skátastarfs' },
        'task-15': { id: 'task-15', content: 'Kvöldvökustjórnun og gítarkennsla | 2.5 klst', name: 'Kvöldvökustjórnun og gítarkennsla' },
        'task-16': { id: 'task-16', content: 'Samskipti og samfélagsmiðlar | 1 klst', name: 'Samskipti og samfélagsmiðlar' },
        'task-17': { id: 'task-17', content: 'Framkoma og ræðumennska | 1 klst', name: 'Framkoma og ræðumennska' },
        'task-18': { id: 'task-18', content: 'Fundarsköp og fundarstjórn | 1 klst', name: 'Fundarsköp og fundarstjórn' },
        'task-19': { id: 'task-19', content: 'Jákvæði skátaforinginn | 1 klst', name: 'Jákvæði skátaforinginn' },
        'task-20': { id: 'task-20', content: 'Aðgengi fyrir alla | 1 klst', name: 'Aðgengi fyrir alla' },
        'task-21': { id: 'task-21', content: 'Alþjóðlegt skátastarf | 1 klst', name: 'Alþjóðlegt skátastarf' },
        'task-22': { id: 'task-22', content: 'Sveitarforinginn - grunnfærni | 2.5 klst', name: 'Sveitarforinginn - grunnfærni' },
        'task-23': { id: 'task-23', content: 'Öruggur foringi á fjöllum | 1 klst', name: 'Öruggur foringi á fjöllum' },
        'task-24': { id: 'task-24', content: 'Ævintýralegi skátaforinginn | 1 klst', name: 'Ævintýralegi skátaforinginn' },
        'task-25': { id: 'task-25', content: 'Skipulagði skátaforinginn | 1 klst', name: 'Skipulagði skátaforinginn' },
        'task-26': { id: 'task-26', content: 'Viðbrögð við áföllum í skátastarfi | 1 klst', name: 'Viðbrögð við áföllum í skátastarfi' },
        'task-27': { id: 'task-27', content: 'Ævintýraferð á Ama Dablam | 1 klst', name: 'Ævintýraferð á Ama Dablam' },
        'task-28': { id: 'task-28', content: 'Flóttinn frá Ingólfi | 1 klst', name: 'Flóttinn frá Ingólfi' },
        'task-29': { id: 'task-29', content: 'Lært í gegnum leik | 1 klst', name: 'Lært í gegnum leik' },

    },
    columns: {
        'NotChosenTasks': {
            id: 'NotChosenTasks',
            title: 'Það sem er í boði',
            taskIds: [
                'task-1',
                'task-2',
                'task-3',
                'task-4',
                'task-5',
                'task-6',
                'task-7',
                'task-8',
                'task-9',
                'task-10',
                'task-11',
                'task-12',
                'task-13',
                'task-14',
                'task-15',
                'task-16',
                'task-17',
                'task-18',
                'task-19',
                'task-20',
                'task-21',
                'task-22',
                'task-23',
                'task-24',
                'task-25',
                'task-26',
                'task-27',
                'task-28',
                'task-29',
            ]
        },
        'ChosenTasks': {
            id: 'ChosenTasks',
            title: 'Það sem ég vil fara í',
            taskIds: []
        }
    },
    // Facilitate reordering of the columns
    columnOrder: ['NotChosenTasks', 'ChosenTasks']
};

export default initalData;


// WEBPACK FOOTER //
// ./src/initial-data.js